<template>
  <div class="permission-controls">
    <h4 class="control-title">Misafir İzinleri</h4>

    <div v-if="hasGuest" class="permissions-list">
      <div class="permission-item">
        <label class="permission-label">
          <input 
            type="checkbox" 
            v-model="permissions.canDraw"
            @change="updatePermissions"
          />
          <span class="checkmark"></span>
          <span class="permission-text">
            <i class="fas fa-pen"></i>
            Çizim Yapabilir
          </span>
        </label>
      </div>
      
      <div class="permission-item">
        <label class="permission-label">
          <input 
            type="checkbox" 
            v-model="permissions.canAddShapes"
            @change="updatePermissions"
          />
          <span class="checkmark"></span>
          <span class="permission-text">
            <i class="fas fa-shapes"></i>
            Şekil Ekleyebilir
          </span>
        </label>
      </div>
      
      <div class="permission-item">
        <label class="permission-label">
          <input 
            type="checkbox" 
            v-model="permissions.canUploadBackground"
            @change="updatePermissions"
          />
          <span class="checkmark"></span>
          <span class="permission-text">
            <i class="fas fa-image"></i>
            Arkaplan Yükleyebilir
          </span>
        </label>
      </div>
      
      <div class="permission-actions">
        <button class="action-btn grant-all" @click="grantAllPermissions">
          <i class="fas fa-check-double"></i>
          Tüm İzinleri Ver
        </button>
        
        <button class="action-btn revoke-all" @click="revokeAllPermissions">
          <i class="fas fa-ban"></i>
          Tüm İzinleri Geri Al
        </button>
      </div>
    </div>
    
    <div v-else class="no-guest-message">
      <i class="fas fa-user-slash"></i>
      <p>Misafir bağlı değil</p>
      <small>Bir misafir katıldığında izinler görünecektir</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PermissionControls',
  data() {
    return {
      hasGuest: false,
      permissions: {
        canDraw: true,
        canAddShapes: true,
        canUploadBackground: false,
        canClear: false,
        canSelect: false,
        canDragCanvas: false,
        canUndo: false,
        canRedo: false
      }
    }
  },
  methods: {
    updatePermissions() {
      // Emit permission updates to parent (HostView)
      this.$emit('permissions-changed', this.permissions)
      console.log('Permissions updated:', this.permissions)
    },
    
    grantAllPermissions() {
      this.permissions.canDraw = true
      this.permissions.canAddShapes = true
      // Permanently restricted for guests
      this.permissions.canClear = false
      this.permissions.canSelect = false
      this.permissions.canDragCanvas = false
      this.permissions.canUndo = false
      this.permissions.canRedo = false
      // Don't grant background permissions for guests
      this.permissions.canUploadBackground = false
      this.updatePermissions()
    },
    
    revokeAllPermissions() {
      Object.keys(this.permissions).forEach(key => {
        this.permissions[key] = false
      })
      this.updatePermissions()
    },
    
    setGuestConnected(connected) {
      this.hasGuest = connected
    }
  },
  mounted() {
    // Simulate guest joining for demo
    setTimeout(() => {
      this.hasGuest = true
    }, 2000)
  }
}
</script>

<style scoped>
.permission-controls {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.control-title {
  margin: 0 0 16px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  text-align: center;
}

.permissions-list {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.permission-item {
  display: flex;
  align-items: center;
}

.permission-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 13px;
  width: 100%;
}

.permission-label input[type="checkbox"] {
  margin-right: 12px;
  transform: scale(1.1);
}

.permission-text {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #555;
  font-weight: 500;
}

.permission-text i {
  font-size: 14px;
  width: 16px;
  color: #007bff;
}

.permission-actions {
  display: flex;
  gap: 8px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}

.action-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s;
}

.grant-all {
  border-color: #28a745;
  color: #28a745;
  background-color: transparent;
}

.grant-all:hover {
  background-color: #28a745;
  color: white;
}

.revoke-all {
  border-color: #dc3545;
  color: #dc3545;
  background-color: transparent;
}

.revoke-all:hover {
  background-color: #dc3545;
  color: white;
}

.no-guest-message {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #6c757d;
  padding: 20px;
}

.no-guest-message i {
  font-size: 32px;
  margin-bottom: 12px;
  opacity: 0.5;
}

.no-guest-message p {
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 500;
}

.no-guest-message small {
  font-size: 12px;
  opacity: 0.7;
}
</style>
